export const Modules = {
  // AI AGENTS
  ai_agent: 'ai_agent',
  AIAgentTeams: 'e_ai_agent_team',
  Copilot: 'CO_PILOT',
  EnterpriseSearch: 'ENTERPRISE_SEARCH',
  MCPServer: 'e_mcp_server',
  AIWorkerDeployment: 'ai_agent_deployment',
  Skill: 'e_skill_ai_agent',

  // AI APPLICATIONS
  NoCodeInterface: 'e_interface',
  NoCodeCustomComponent: 'e_custom_component',
  NoCodeComponent: 'e_component',
  NoCodeTemplateComponent: 'NO_CODE_TEMPLATE_COMPONENT',
  // AI Workflows
  WorkflowDefinition: 'WORKFLOW_DEFINITION',
  api_platform: 'API_ENDPOINT',
  decision_tables: 'e_decision_table',
  CallableInterface: 'CALLABLE_INTERFACE',

  // AI Ontology & Data
  ContextGraph: 'ContextGraph',
  UnifiedEntityModel: 'UNIFIED_ENTITY_MODEL',
  PipelineConfig: 'DATA_PIPELINE',
  data_catalog: 'e_data_catalog',
  DataQuality: 'DATA_QUALITY',
  e_streams: 'e_streams',
  e_campaign: 'e_campaign',
  SegmentDefinition: 'SEGMENT_DEFINITION',

  // Enterprise Resources
  EntityType: 'ENTITY_TYPE',
  KnowledgeSet: 'knowledge_set',
  MemorySet: 'memory_profile_set',
  People: 'PEOPLE',
  CodeSnippet: 'e_code_snippet',
  e_template: 'e_template',
  Prompt: 'e_prompt',

  // Enterprise Systems
  Connection: 'CONNECTION',
  ConnectorDefinition: 'CONNECTOR_DEFINITION',

  // AI Governance
  AIModels: 'ai_agent_llm_model', // TODO: check
  Guardrails: 'GUARDRAILS',
  Security: 'IDENTITY_PROVIDER',
  AlertDefinition: 'ALERT_DEFINITION',
  Experiments: 'experiment',
  Datasets: 'dataset',
  Metrics: 'e_ai_evaluation_metric',
  MeteringModel: 'METERING_MODEL',
  MeteringAgent: 'METERING_AGENT',
  MeteringSearch: 'METERING_SEARCH',
  MeteringUser: 'METERING_USER',
  Changeset: 'CHANGESET',
  ChangesetRequest: 'CHANGESET_REQUEST',
  CustomerEnvironment: 'CUSTOMER_ENVIRONMENT',
  WorkflowLibrary: 'TEMPLATE',
  AgentWorkflow: 'AGENT_WORKFLOW',

  // TODO : ADD LATER
  // ApplicationTemplates: 'APPLICATION_TEMPLATES',
  // AgentTemplates: 'AGENT_TEMPLATES',
  // PromptTemplates: 'PROMPT_TEMPLATES',

  AccessProfile: 'ACCESS_PROFILE',
  SimpleAgent: 'SIMPLE_AGENT',
  APIClient: 'API_CLIENT',
  APIEndpointCollection: 'API_ENDPOINT_COLLECTION',
  APIPolicy: 'API_POLICY',
  ApiReport: 'API_REPORT',
  BusinessHolidays: 'e_business_holiday',
  BusinessHours: 'e_business_hours',
  ConnectorResourceDefinition: 'CONNECTOR_RESOURCE_DEFINITION',
  EnvironmentVariables: 'e_env_variables',
  Notification: 'NOTIFICATIONS',
  Help: 'HELP',
  overview: 'PROJECT_OVERVIEW',
  Project: 's_project',
  Reporting: 'REPORTING',
  Roles: 'ROLE_DEFINITION',
  runtime_environments: 'RemoteRuntimeEnvironment',
  DataManagement: 'DATA_MANAGEMENT',
  BackupManager: 'BACKUP_MANAGER',
  Teams: 'USER_GROUP',
  UnifiedEntityAccessControl: 'UNIFIED_ENTITY_ACCESS_CONTROL',
  MDM: 'MDM_MODEL',
  User: 'USER',
  Settings: 'settings',
  UserMenu: 'userMenu',
  DataRetention: 'DATA_RETENTION',
  CustomModels: 'CUSTOM_MODELS',
  ThemeBuilder: 'THEME_BUILDER',
  Knowledge: 'knowledge',
  A2AServer: 'e_a2a_server',
  Evaluation: 'EVALUATION',
  AIAgentsSetup: 'AI_AGENTS_SETUP',
  AIMetering: 'AI_METERING',
  PlatformBackup: 'PLATFORM_BACKUP_CONFIG',
  ThemeManager: 'e_theme',
  Tag: 'TAG',
  SystemHealth: 'SYSTEM_HEALTH',

  // AGENT GOVERNANCE
  AgentGovernance: 'AGENT_GOVERNANCE',
  AgentGovernanceDiscovery: 'AGENT_GOVERNANCE_DISCOVERY',
  AgentGovernanceRegistry: 'AGENT_GOVERNANCE_REGISTRY',
  AgentGovernanceModelRegistry: 'AGENT_GOVERNANCE_MODEL_REGISTRY',
  AgentGovernanceMonitoring: 'AGENT_GOVERNANCE_MONITORING',
  AgentGovernanceFinops: 'AGENT_GOVERNANCE_FINOPS',
  AgentGovernanceCostExplorer: 'AGENT_GOVERNANCE_COST_EXPLORER',
  AgentGovernanceFinopsOutcomes: 'AGENT_GOVERNANCE_FINOPS_OUTCOMES',
  Policies: 'POLICIES',
  Controls: 'CONTROLS',
  Incidents: 'INCIDENTS',
} as const;

export type ModuleValues =
  | (typeof Modules)[keyof typeof Modules]
  | 'e_component_form'
  | 'e_component_field';

// NOTE: This is needed because we do not get entity permissions for all modules
export const ModulesWithoutEntityPermissions = [
  Modules.Notification,
  Modules.Help,
] as ModuleValues[];
